import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const ActionPanelElementFields = {
  group: ELEMENT_GROUPS.TEXT,
  label: 'Action Panel',
  icon: 'DocumentTextIcon',
  description: 'Adds a text block for free-style text',
  properties: [
    'layout',
    {
      label: 'Text',
      name: 'text',
      editor: 'textbox',
      description: 'The text to display in the field',
      default: 'my new text',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'fontFamily',
    'color',
    'font',
    'alignment',
    'margin',
    'padding'
  ]
};

export default ActionPanelElementFields;
